import imageCompression from "browser-image-compression";

export async function compressImage(file) {
    const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1600,
        useWebWorker: true,
        initialQuality: 0.7,
        fileType: "image/jpeg",
    };
    try {
        return await imageCompression(file, options);
    } catch {
        return file;
    }
}

// Khusus pola warna: teks di gambar harus tetap terbaca — resolusi & kualitas lebih tinggi.
export async function compressImageHQ(file) {
    const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 3000,
        useWebWorker: true,
        initialQuality: 0.9,
        fileType: "image/jpeg",
    };
    try {
        return await imageCompression(file, options);
    } catch {
        return file;
    }
}
